var _path, _g, _path2, _path3, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_310_12794",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 16,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6767 11.3419H17.6685V9.4298C17.6685 5.22323 14.6144 1.78149 10.2326 1.78149C5.85077 1.78149 2.26562 5.22323 2.26562 9.4298V11.3419H4.25737V9.4298C4.25737 6.27487 6.94623 3.69357 10.2326 3.69357C13.519 3.69357 15.6767 6.27487 15.6767 9.4298V11.3419ZM15.6441 19.2815H10.4217L10.4061 19.2814C9.62654 19.2733 8.99709 18.6467 8.99709 17.8748C8.99709 17.0979 9.63476 16.4681 10.4214 16.4681C11.0415 16.4681 11.5691 16.8595 11.7646 17.4059H15.6441L15.7642 16.1018C15.7642 15.7821 15.8405 15.8257 16.0108 15.9229C16.1402 15.9968 16.3241 16.1018 16.5702 16.1018C16.8162 16.1018 17.0001 15.9968 17.1296 15.9229C17.2998 15.8257 17.3761 15.7821 17.3761 16.1018L17.5431 17.4059C17.5431 18.4375 16.6885 19.2815 15.6441 19.2815Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_310_12794)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.26562,
    y: 1.78149,
    width: 15.934,
    height: 18.0585,
    fill: "url(#paint0_linear_310_12794)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6435 10.0945H17.768C18.9365 10.0945 19.8926 11.0505 19.8926 12.219V14.3435C19.8926 15.512 18.9365 16.4681 17.768 16.4681H15.6435V10.0945ZM4.24906 16.4681H2.12453C0.956038 16.4681 0 15.512 0 14.3435V12.219C0 11.0505 0.956038 10.0945 2.12453 10.0945H4.24906V16.4681Z",
    fill: "url(#paint1_linear_310_12794)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_310_12794",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 10,
    width: 20,
    height: 7
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6435 10.0945H17.768C18.9365 10.0945 19.8926 11.0505 19.8926 12.219V14.3435C19.8926 15.512 18.9365 16.4681 17.768 16.4681H15.6435V10.0945ZM4.24906 16.4681H2.12453C0.956038 16.4681 0 15.512 0 14.3435V12.219C0 11.0505 0.956038 10.0945 2.12453 10.0945H4.24906V16.4681Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_310_12794)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.920898,
    y: 9.21729,
    width: 21.2453,
    height: 8.49811,
    fill: "url(#paint2_linear_310_12794)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_310_12794",
    x1: 2.26562,
    y1: 1.78149,
    x2: 2.26562,
    y2: 19.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_310_12794",
    x1: 0,
    y1: 10.0945,
    x2: 0,
    y2: 16.4681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CC1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#468DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_310_12794",
    x1: -0.920898,
    y1: 9.21729,
    x2: -0.920898,
    y2: 17.7154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSupport);
export default __webpack_public_path__ + "static/media/ic_support.b77dde04.svg";
export { ForwardRef as ReactComponent };